define('js/lib/mixpanel',[
    'vendor/mixpanel',
    'js/config/clientSideConfig',
    'js/lib/getUser'
], function (
    mixpanel,
    getConfig,
    getUser
) {
    'use strict';

    return {
        init: function() {
            try {
                getUser.getPromise().then(function (user) {
                    var config = getConfig();
                    mixpanel.init(config.mixpanelToken);
                    !!user && mixpanel.identify(user.id);
                    mixpanel.register({
                        clientId: !!user ? user.clientId : '',
                        app: 'bootstrap'
                    });

                }, function () {
                    //not signed in yet, no worries
                });
            } catch (e) {
                //something went wrong initializing mixpanel, fail silently
                console.warn('Mixpanel failed to initialize', e);
            }
        },

        get: function() {
            return mixpanel;
        }
    };
});
